import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";

import { ISprocessoMarcador, ProcessoMarcador } from "../../../types/processo/ProcessoMarcador";
import { ProcessoMarcadorDTO } from "../../../types/processo/ProcessoMarcadorDTO";
import { useAddProcessoMarcadorMutation, useGetProcessoMarcadorQuery } from "../processoApiSlice";
import TxtMarcador from "../../autoComplete/TxtMarcador";
import { ISmarcador, Marcador } from "../../../types/marcador/Marcador";


export const ProcessoMarcadorCreate = () => {

    const [marcadorSelecionado, setMarcadorSelecionado] = useState<Marcador>(ISmarcador);

    const [processoMarcador, SetProcessoMarcador] = useState<ProcessoMarcador>(ISprocessoMarcador);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createMarcador, status] = useAddProcessoMarcadorMutation();
    const navigate = useNavigate();

    // Hook para seleção do processo
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);


    //verificar se for edicao ele pega o id e faz a consulta 
    const id = useParams().id || "";
    const { data, isFetching, error } = useGetProcessoMarcadorQuery(id);
    useEffect(() => {
        if (data) {
            SetProcessoMarcador(data);
        }
    }, [data, error, isFetching])





    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        SetProcessoMarcador((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const parms: ProcessoMarcadorDTO = {
            id: processoMarcador.id,
            marcadorID: processoMarcador.marcador.id ? processoMarcador.marcador.id : "",
            processoID: processoSelecionado ? processoSelecionado.id : "",
        }
        await createMarcador(parms);
    }

    useEffect(() => {

       

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);


    const handletxtMarcadorChange = (marcador: Marcador) => {
        setMarcadorSelecionado(marcador as Marcador);
        SetProcessoMarcador((prev) => ({
            ...prev,
            marcador: marcador as Marcador,
        }));
    };





    return (



        <>


            <Paper>

             

                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>
                        <Grid container spacing={3}>

                            <Grid item xs={12}>
                                <FormControl fullWidth>

                                    <Box display="flex" justifyContent="space-between" mb={2}>

                                        <Box display="flex">
                                            <Typography color="secondary" variant="h6" gutterBottom>
                                                Marcadores para o processo: {processoSelecionado?.numeroProcesso}
                                            </Typography>
                                        </Box>


                                        <Box display="flex" justifyContent="flex-end" gap={2}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => { navigate(configUrls.MARCADOR_CREATE_RT) }}
                                            >
                                                Novo Marcador
                                            </Button>




                                        </Box>
                                    </Box>




                                </FormControl>
                            </Grid>








                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between" gap={2}>
                                    <FormControl fullWidth>
                                        <TxtMarcador
                                            value={processoMarcador.marcador}
                                            handleSearchChange={(it) => {
                                                handletxtMarcadorChange(it);
                                            }}
                                        />
                                    </FormControl>



                                </Box>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>






                </Box>

            </Paper >










        </>







    );










};

/*
 <GrupoTurmaForm
                    grupoTurma={grupoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/